import React, { useEffect, useState } from "react";

// import Sidebar from "../partials/Sidebar";
// import Header from "../partials/Header";
import SearchForm from "../partials/actions/SearchForm";
import TeamTilesCard from "../partials/team/TeamTilesCard";
import ModalBasic from "../components/ModalBasic";
import AsyncSelect from "react-select/async";
import makeAnimated from "react-select/animated";
import _ from "lodash";
import { Navigate } from "react-router-dom";
import { requestDelete, requestGet, requestPost, requestPut } from "../api/coreInstance";
import withAuth from "../components/withAuth";

const animatedComponent = makeAnimated();

function Dashboard() {
   const [showModalNotification, setShowModalNotification] = useState(false);
   const [options, setOptions] = useState({
      outlets: [],
   });
   const [fillNotifications, setFillNotifications] = useState({
      notif_cat_id: "1",
      title: "",
      content: "",
      channel_id: null,
      outlet_kartini_id: null,
      akuisisi_id: null,
      action: "Add",
   });

   const [notificationsData, setNotificationsData] = useState([]);
   const [user] = useState(JSON.parse(localStorage.getItem("dompet_user")));

   useEffect(() => {
      GetOptionsData();
   }, []);

   useEffect(() => {
      GetNotificationsData();
   }, []);

   // function initialFillNotifications() {
   //   setFillNotifications({
   //     notif_cat_id: "",
   //     title: "",
   //     content: "",
   //     channel_id: null,
   //     outlet_kartini_id: null,
   //     akuisisi_id: null,
   //     action: "Add",
   //   });
   // }

   function GetNotificationsData() {
      var requestOptions = {
         redirect: "follow",
      };

      requestGet(`/notif`, requestOptions)
         .then((res) => setNotificationsData([...res.data.data]))
         .catch((error) => console.error(error));
   }

   function GetOptionsData() {
      var myHeaders = new Headers();
      myHeaders.append("X-Kartini-Signature", "a2FydGluaUAyMDIy");

      var requestOptions = {
         redirect: "follow",
      };

      requestGet(`/channel`, requestOptions)
         .then((res) =>
            setOptions((prevState) => ({
               ...prevState,
               outlets: res.data.data.map((outlet) => ({
                  label: outlet.channel_sub_sub_category,
                  value: outlet.channel_id,
               })),
            }))
         )
         .catch((error) => console.error(error));
   }

   function AddNotification() {
      var data = JSON.stringify({
         ...fillNotifications,
         channel_id: fillNotifications.channel_id,
         outlet_kartini_id: fillNotifications.outlet_kartini_id,
      });

      var requestOptions = {
         redirect: "follow",
      };

      requestPost(`/notif`, data, requestOptions)
         .then((res) => console.log(res))
         .catch((error) => console.error(error));

      GetNotificationsData();
      setShowModalNotification(false);
   }

   function EditNotification() {
      var data = JSON.stringify({
         ...fillNotifications,
         channel_id: _.isArray(fillNotifications.channel_id)
            ? "," +
              fillNotifications.channel_id
                 .map((select) => select.value)
                 .toString() +
              ","
            : fillNotifications.channel_id,
         outlet_kartini_id: _.isArray(fillNotifications.outlet_kartini_id)
            ? "," +
              fillNotifications.outlet_kartini_id
                 .map((select) => select.value)
                 .toString() +
              ","
            : fillNotifications.outlet_kartini_id,
      });

      var requestOptions = {
         redirect: "follow",
      };

      requestPut(`/notif/${fillNotifications.notif_id}`, data, requestOptions)
         .then((res) => console.log(res))
         .catch((error) => console.error(error));

      GetNotificationsData();
      GetNotificationsData();
      setShowModalNotification(false);
   }

   function DeleteNotification(data) {
      var requestOptions = {
         redirect: "follow",
      };

      requestDelete(`/notif/${data.notif_id}`, requestOptions)
         .then((res) => console.log(res))
         .catch((error) => console.error(error));

      GetNotificationsData();
      GetNotificationsData();
   }

   function InitializeFillNotifications(event) {
      setFillNotifications({
         notif_cat_id: "1",
         title: "",
         content: "",
         channel_id: null,
         outlet_kartini_id: null,
         akuisisi_id: null,
         action: event,
      });
   }

   const loadChannel = async (search, callback) => {
      await requestGet(
            `/v2/collection/channel/data?query=${search}&length=0`
         )
         .then((res) => {
            console.log(res.data.data);
            var options = [
               {
                  label: `All ${search}`,
                  value: res.data.data.map((option) => option.channel_id),
               },
            ];
            callback(
               options.concat(
                  res.data.data.map((option) => ({
                     label: option.channel_sub_sub_category,
                     value: [option.channel_id],
                  }))
               )
            );
         })
         .catch((error) => console.error(error));
   };

   const loadOutlet = async (search, callback) => {
      await requestGet(
            `/outlet/kartini?channel_id=${fillNotifications.channel_id.toString()}query=${search}`
         )
         .then((res) => {
            var options = [
               {
                  label: `All ${search}`,
                  value: res.data.data.map(
                     (option) => option.outlet_kartini_id
                  ),
               },
            ];
            callback(
               options.concat(
                  res.data.data.map((option) => ({
                     label: option.outlet_kartini_name,
                     value: [option.outlet_kartini_id],
                  }))
               )
            );
         })
         .catch((error) => console.error(error));
   };

   function SetWidget() {
      return notificationsData.map((item) => {
         return (
            <TeamTilesCard
               key={item.notif_id ?? ""}
               data={item}
               id={item.notif_id ?? ""}
               name={item.title ?? ""}
               image={item.image ?? ""}
               link={item.link ?? ""}
               content={item.content ?? ""}
               InitializeFillNotifications={InitializeFillNotifications}
               setShowModalNotification={setShowModalNotification}
               setFillNotification={setFillNotifications}
               DeleteNotification={DeleteNotification}
            />
         );
      });
   }

   return user && user.user_type !== "admin" ? (
      <Navigate to="/admin_login" />
   ) : (
      <div className="flex h-screen overflow-hidden">
         {/* ADD NOTIFICATION */}
         <ModalBasic
            id="feedback-modal"
            modalOpen={showModalNotification}
            setModalOpen={setShowModalNotification}
            title="Notifications"
         >
            {/* Modal content */}
            <div className="px-5 py-4">
               <div className="space-y-3">
                  <div>
                     <label
                        className="block text-sm font-medium mb-1"
                        htmlFor="title"
                     >
                        Title <span className="text-red-500">*</span>
                     </label>
                     <input
                        id="title"
                        className="form-input w-full px-2 py-1"
                        type="text"
                        value={fillNotifications.title ?? ""}
                        required
                        onChange={(e) =>
                           setFillNotifications((prevState) => ({
                              ...prevState,
                              title: e.target.value,
                           }))
                        }
                     />
                  </div>
                  <div>
                     <label
                        className="block text-sm font-medium mb-1"
                        htmlFor="content"
                     >
                        Content <span className="text-red-500">*</span>
                     </label>
                     <textarea
                        id="content"
                        className="form-textarea w-full px-2 py-1"
                        rows="4"
                        value={fillNotifications.content ?? ""}
                        required
                        onChange={(e) => {
                           setFillNotifications((prevState) => ({
                              ...prevState,
                              content: e.target.value,
                           }));
                        }}
                     ></textarea>
                  </div>
                  <div>
                     <label
                        className="block text-sm font-medium mb-1"
                        htmlFor="notif"
                     >
                        Notification For Channel{" "}
                        <span className="text-red-500">*</span>
                     </label>
                     <AsyncSelect
                        isMulti
                        className="col-span-full sm:col-span-2"
                        components={animatedComponent}
                        defaultOptions={[{ label: "All", value: "" }]}
                        placeholder="Outlet Search"
                        loadOptions={loadChannel}
                        onChange={(option) => {
                           var o_id = "";
                           option.map((o) => {
                              if (o.label) {
                                 if (o.label.includes("All")) {
                                    o_id +=
                                       o_id.charAt(o_id.length - 1) !== "," &&
                                       o_id.length !== 0
                                          ? "," + o.value.toString()
                                          : o.value.toString();
                                    return o.value.toString();
                                 } else {
                                    o_id +=
                                       o_id.charAt(o_id.length - 1) !== "," &&
                                       o_id.length !== 0
                                          ? "," + o.value[0].toString()
                                          : o.value[0].toString();
                                    // o_id += o.value[0].toString()
                                    return o_id;
                                 }
                              }
                           });
                           setFillNotifications((prevState) => ({
                              ...prevState,
                              channel_id: o_id,
                           }));
                        }}
                     />
                  </div>
                  <div>
                     <label
                        className="block text-sm font-medium mb-1"
                        htmlFor="content"
                     >
                        Notification For Outlet
                        <span className="text-red-500">*</span>
                     </label>
                     <AsyncSelect
                        isMulti
                        isDisabled={
                           _.isEmpty(fillNotifications.channel_id) ?? false
                        }
                        className="col-span-full sm:col-span-2"
                        components={animatedComponent}
                        defaultOptions={[{ label: "All", value: "" }]}
                        placeholder="Outlet Search"
                        loadOptions={loadOutlet}
                        onChange={(option) => {
                           var o_id = "";
                           option.map((o) => {
                              if (o.label) {
                                 if (o.label.includes("All")) {
                                    o_id +=
                                       o_id.charAt(o_id.length - 1) !== "," &&
                                       o_id.length !== 0
                                          ? "," + o.value.toString()
                                          : o.value.toString();
                                    return o.value.toString();
                                 } else {
                                    o_id +=
                                       o_id.charAt(o_id.length - 1) !== "," &&
                                       o_id.length !== 0
                                          ? "," + o.value[0].toString()
                                          : o.value[0].toString();
                                    // o_id += o.value[0].toString()
                                    return o_id;
                                 }
                              }
                           });
                           setFillNotifications((prevState) => ({
                              ...prevState,
                              outlet_kartini_id: o_id,
                           }));
                        }}
                     />
                  </div>
               </div>
            </div>
            {/* Modal footer */}
            <div className="px-5 py-4 border-t border-gray-200">
               <div className="flex flex-wrap justify-end space-x-2">
                  <button
                     className="btn-sm border-gray-200 hover:border-gray-300 text-gray-600"
                     onClick={(e) => {
                        e.stopPropagation();
                        setShowModalNotification(false);
                     }}
                  >
                     Cancel
                  </button>
                  <button
                     className="btn-sm bg-[#4CA6F8] text-white"
                     onClick={() => {
                        if (fillNotifications.action === "Add") {
                           AddNotification();
                        } else if (fillNotifications.action === "Edit") {
                           EditNotification();
                        }
                     }}
                  >
                     {`${fillNotifications.action} Notification`}
                  </button>
               </div>
            </div>
         </ModalBasic>
         {/* Sidebar */}
         {/* <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} /> */}

         {/* Content area */}
         <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
            {/*  Site header */}
            {/* <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} /> */}

            <main>
               <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                  {/* Page header */}
                  <div className="sm:flex sm:justify-between sm:items-center mb-8">
                     {/* Left: Title */}
                     <div className="mb-4 sm:mb-0">
                        <h1 className="text-2xl md:text-3xl text-gray-800 font-bold">
                           Notification 🔔
                        </h1>
                     </div>

                     {/* Right: Actions */}
                     <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                        {/* Search form */}
                        <SearchForm />
                        {/* Add member button */}
                        <button
                           className="btn bg-indigo-500 hover:bg-indigo-600 text-white"
                           onClick={() => {
                              InitializeFillNotifications("Add");
                              setShowModalNotification(true);
                           }}
                        >
                           <svg
                              className="w-4 h-4 fill-current opacity-50 flex-shrink-0"
                              viewBox="0 0 16 16"
                           >
                              <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                           </svg>
                           <span className="ml-2">Add Notification</span>
                        </button>
                     </div>
                  </div>

                  {/* Cards */}
                  <div className="grid grid-cols-12 gap-6">{SetWidget()}</div>

                  {/* Pagination */}
                  {/* <div className="mt-8">
            <PaginationNumeric />
          </div> */}
               </div>
            </main>
         </div>
      </div>
   );
}

export default withAuth(Dashboard);
